import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode, dataObjectReference, float32Array, uint32Array} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {descriptorDefinition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const topology = z.literal("triangleList")

export const geometry = z.object({
    topology: topology,
    vertices: z.object({
        positions: float32Array, // in pixel space
        uvs: float32Array.optional(), // in pixel space; default: {x: 0, y: 0}
        colors: float32Array.optional(), // default: {r: 1, g: 1, b: 1, a: 1}
    }),
    indices: uint32Array.optional(), // default: [0, 1, 2, 3, 4, 5, ...]
})

export type Geometry = z.infer<typeof geometry>

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            geometry: geometry.or(dataObjectReference),
            // worldTransform: matrix3x2Like.optional(),
            textureImage: anyImageOpResult.optional(),
            addressMode: AddressMode.optional().default("clamp"),
            descriptor: descriptorDefinition,
        }),
    },
}
